import React, { useMemo } from 'react';
import { useParams, useOutletContext } from 'react-router-dom';
import CustomerCustomPageContent from '../components/custom-pages/CustomerCustomPageContent';
import { getLandingPageBySlug } from '../utils/custom-pages/pageConfig';

const CustomPage = ({ pageSlugOverride = '' }) => {
  const { companyUrl, pageSlug } = useParams();
  const { companyData } = useOutletContext();
  const selectedPage = useMemo(() => {
    const resolvedPageSlug = pageSlugOverride || pageSlug;
    return getLandingPageBySlug(companyData?.landingPageSettings, resolvedPageSlug, companyData);
  }, [companyData, pageSlug, pageSlugOverride]);

  if (!selectedPage || selectedPage.isVisible === false) {
    return (
      <div className="error-container">
        <h2>Page unavailable</h2>
        <p>The page you requested could not be found.</p>
      </div>
    );
  }

  return (
    <section className="services-section">
      <div className="container">
        <CustomerCustomPageContent companyData={companyData} page={selectedPage} />
      </div>
    </section>
  );
};

export default CustomPage;
